import {
    QueryClient,
} from '@tanstack/react-query'
import {
    RequestKeys,
} from 'app/hooks/useRequest'

const queryClient = new QueryClient()

export default queryClient
export const invalidateQueries = (keys: RequestKeys[]) => {
    return queryClient.invalidateQueries({
        queryKey: keys,
    })
}
